module.exports = __webpack_public_path__ + "img/1440.6c2aa700.jpg";